import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { FeatureFlagsConfig } from '@app/configs/feature-flags/feature-flags.config';

@Injectable({
	providedIn: 'root',
})
export class FeatureFlagService {
	/*This is a simple implementation, will be improved later*/
	private readonly featureFlagsStorageKey = 'featureFlags';

	constructor() {
		this.syncLocalStorageWithConfig();
	}

	toggleFeatureFlag(flagName: string): void {
		const localStorageFlags = JSON.parse(
			localStorage.getItem(this.featureFlagsStorageKey) || '{}'
		);
		const currentValue = this.getCurrentFeatureFlagValue(flagName);
		if (currentValue == null) {
			console.error(`Feature flag "${flagName}" does not exist`);
			return;
		}
		localStorageFlags[flagName] = !currentValue;
		localStorage.setItem(this.featureFlagsStorageKey, JSON.stringify(localStorageFlags));
	}

	isFFEnabled(flagName: string): boolean {
		const currentValue = this.getCurrentFeatureFlagValue(flagName);

		if (currentValue == null) {
			console.error(`No value found for Feature flag "${flagName}"`);
			return false;
		}

		return !!currentValue;
	}

	private getCurrentFeatureFlagValue(flagName: string): boolean | undefined {
		const localStorageFlags = JSON.parse(
			localStorage.getItem(this.featureFlagsStorageKey) || '{}'
		);
		if (localStorageFlags[flagName] != undefined) {
			return !!localStorageFlags[flagName];
		}
		const defaultConfig = FeatureFlagsConfig.find(({ key }) => key === flagName);
		if (defaultConfig?.defaultValue != null) {
			return !!defaultConfig.defaultValue;
		}

		// The name does not match any configured feature names
		return undefined;
	}

	private syncLocalStorageWithConfig(): void {
		const localStorageFlags = JSON.parse(
			localStorage.getItem(this.featureFlagsStorageKey) || '{}'
		);
		const configFlagsMap = new Set(FeatureFlagsConfig.map(flag => flag.key));

		if (environment.production) {
			// Remove flags from localStorage that are not in the config
			Object.keys(localStorageFlags).forEach(flag => {
				if (!configFlagsMap.has(flag)) {
					delete localStorageFlags[flag];
				} else if (flag === 'enable-tiles') {
					delete localStorageFlags[flag]; // force reset the tiles feature flag in production
				}
			});
		}

		localStorage.setItem('featureFlags', JSON.stringify(localStorageFlags));
	}
}
